import { AVATAR_ACTION_ID } from "./constants";
import { isIndiaCountryCode } from "./otpPhone";

export function shouldShowHeaderAvatarMenuItem(
  itemId: number,
  loginMethod: string | null | undefined,
  isdCode?: string | null,
): boolean {
  if (
    itemId === AVATAR_ACTION_ID.SWITCH_PRODUCT &&
    isdCode &&
    !isIndiaCountryCode(isdCode)
  ) {
    return false;
  }

  if (loginMethod === "phone_otp") {
    return true;
  }

  if (loginMethod === "admission_id") {
    return itemId !== AVATAR_ACTION_ID.SWITCH_PROFILE;
  }

  return (
    itemId !== AVATAR_ACTION_ID.SWITCH_PROFILE &&
    itemId !== AVATAR_ACTION_ID.SWITCH_PRODUCT
  );
}
